import {priority} from '@priority-software/priority-proto-api/lib';
import {RuleOperators} from '../../enum';
import {operatorsWithValue} from '../../../../constants';

export const isValidCondition = (conditions: priority.netitems.form.IAlertCondition[]) => {
    // the last condition should always be valid
    const condition = conditions[conditions.length - 1];
    if (condition) {
        const basicRequirement =
            condition.CurrentValue && condition.ConditionOperator && condition.ConditionField;

        if (basicRequirement) {
            const hasAdditionalFields = operatorsWithValue.includes(
                Number(condition.ConditionOperator)
            );

            if (hasAdditionalFields) {
                if (condition.ConditionOperator === RuleOperators.fallsBetween) {
                    return condition.ConditionValue && condition.ConditionSecondValue;
                }

                return !!condition.ConditionValue;
            }
        }

        return basicRequirement;
    }
    return true;
};
